import { getLicensingStatus, getSystemFlags } from 'core/core.selectors';
import { verifyNemadigitalConfigAvailability } from 'pages/nemadigital/nemadigital.selectors';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { lazyRoute } from './lazy-route';

const NemaDigitalMapViewWorkspaceContainer = lazyRoute(() => import('pages/nemadigital/map-view/nemadigital-map-view-workspace.container'));

const NemaDigitalMapViewWorkspace = () => {
  const systemFlags = useSelector(getSystemFlags);
  const licensingStatus = useSelector(getLicensingStatus);
  const hasAccess = useSelector(verifyNemadigitalConfigAvailability);

  if (!systemFlags || !licensingStatus) {
    return null;
  }

  if (!systemFlags.NEMA_1276_show_nema_workspace_map_view_mfe || !hasAccess) {
    return <Navigate to='/hall-of-companies' />;
  }

  return <NemaDigitalMapViewWorkspaceContainer />;
};

export default NemaDigitalMapViewWorkspace;
